/**
 * SEO component manages document head tags for search engine optimization.
 * It sets the page title, description, canonical URL, Open Graph tags, and structured data.
 * @param {Object} props - Component properties.
 * @param {string} props.title - The title of the page.
 * @param {string} props.description - The description of the page for search engines.
 * @param {string} [props.path="/"] - The URL path of the current page.
 */
export default function SEO({
    title,
    description,
    path = "/"
}) {
    const defaultTitle = "Kahoot Bot | #1 Free Kahoot Bots, Spammer & Flooder";
    const defaultDesc = "Flood any game with bots using the best Kahoot Bot. Our Spammer and Sender tools work instantly with no download required.";
    const siteUrl = "https://kahoot-bot.net";

    const finalTitle = title ? `${title} | Kahoot-Bot.net` : defaultTitle;
    const finalDesc = description || defaultDesc;
    const finalUrl = siteUrl + path;

    return (
        <>
            <title>{finalTitle}</title>
            <meta name="description" content={finalDesc} />
            <link rel="canonical" href={finalUrl} />

            <meta property="og:type" content="website" />
            <meta property="og:title" content={finalTitle} />
            <meta property="og:description" content={finalDesc} />
            <meta property="og:url" content={finalUrl} />

            <script type="application/ld+json">
                {JSON.stringify({
                  "@context": "https://schema.org",
                  "@type": "SoftwareApplication",
                  "name": "Kahoot Bot",
                  "applicationCategory": "EducationalApplication",
                  "operatingSystem": "Web",
                  "offers": {
                    "@type": "Offer",
                    "price": "0",
                    "priceCurrency": "USD"
                  },
                  "aggregateRating": {
                      "@type": "AggregateRating",
                      "ratingValue": "4.8",
                      "ratingCount": "1250"
                  }
                })}
            </script>
        </>
    );
}